import { useEffect, useId, useRef } from 'react'
import {
  BANNER_HEIGHTS,
  getAdMode,
  getYahooBannerTagId,
  type AdScreen,
  type BannerSize,
} from '../config/ads'
import { initializeYahooAdTag } from '../services/ads'
import { isCapacitorNative } from '../utils/platform'

interface Props {
  screen: AdScreen
  size?: BannerSize
}

export function AdBanner({ screen, size = 'standard' }: Props) {
  const initializedRef = useRef(false)
  const reactId = useId().replace(/:/g, '')
  const tagId = getYahooBannerTagId(screen)
  const elementId = tagId ? `yads${tagId}_${reactId}` : `yads-placeholder-${screen}-${reactId}`
  const height = BANNER_HEIGHTS[size]

  useEffect(() => {
    if (isCapacitorNative() || typeof document === 'undefined') return
    document.documentElement.style.setProperty('--admob-banner-height', `${height}px`)
    return () => {
      document.documentElement.style.setProperty('--admob-banner-height', '0px')
    }
  }, [height])

  useEffect(() => {
    if (isCapacitorNative()) return
    if (getAdMode() !== 'production') return
    if (!tagId) return
    if (initializedRef.current) return
    initializedRef.current = initializeYahooAdTag(elementId, tagId)
  }, [elementId, tagId])

  if (isCapacitorNative()) return null

  if (getAdMode() !== 'production' || !tagId) {
    return (
      <div className="ad-banner ad-banner--placeholder" style={{ height }}>
        <span className="ad-banner__badge">AD</span>
        <span className="ad-banner__text">Yahoo 広告プレースホルダー</span>
      </div>
    )
  }

  return (
    <div className="ad-banner ad-banner--production" style={{ height }}>
      <div id={elementId} className="ad-banner__slot">
        <span className="ad-banner__loader" aria-hidden="true" />
      </div>
    </div>
  )
}

export default AdBanner
